import axios from "axios";
import { handleError } from "./helper/error";
import { handleSend } from "./helper/send";
import { handleOptions } from "@/common/http/helper/handleOptions";
import { isNone } from "@/utils/assist";

//
const pending = new Map();

export default function(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create(handleOptions(options));

    const addPending = config => {
      let url = [
        config.method,
        config.url.indexOf("?") ? config.url.split("?")[0] : config.url
      ].join("&");
      config.cancelToken =
        config.cancelToken ||
        new axios.CancelToken(cancel => {
          if (!pending.has(url)) pending.set(url, cancel);
        });
    };
    const removePending = config => {
      let url = [
        config.method,
        config.url.indexOf("?") ? config.url.split("?")[0] : config.url
      ].join("&");
      // if (pending.has(url)) {
      //   const cancel = pending.get(url);
      //   cancel(url);
      //   pending.delete(url);
      // }
    };

    // 对请求参数的处理
    instance.interceptors.request.use(
      config => {
        if (isNone(options.isCancel)) {
          removePending(config);
          addPending(config);
        }
        return config;
      },
      error => Promise.reject(error)
    );
    //
    instance.interceptors.response.use(
      response => {
        if (isNone(options.isCancel)) {
          removePending(response.config); //
        }
        let { data } = response;
        if (data.errcode === "0" || data.errcode === 0 ) {
          resolve(data);
        } else {
          handleError(data, options);
          reject(response);
        }
      },
      error => {
        try {
          if (axios.isCancel(error)) {
            // console.log('repeated request: ' + error.message);
          }
          handleError(
            {
              errcode: "500",
              message: error.response.data
            },
            options
          );
          reject(error.response.data);
        } catch (e) {
          reject(error);
        }
      }
    );
    handleSend(instance, options);
  });
}
